import { HelpCircle } from "@untitledui/icons";
import { Badge } from "@/components/base/badges/badges";
import { useChecklistProgressStore, usePhotoOnboardingStore } from "../store";
import { PhotoOnboarding } from "./photo-onboarding";

type StepHeaderProps = {
	title?: string;
	subtitle?: string;
	hasFileUpload?: boolean;
};

export const StepHeader = ({
	title,
	subtitle,
	hasFileUpload = false,
}: StepHeaderProps) => {
	const currentStep = useChecklistProgressStore((state) => state.currentStep);
	const totalSteps = useChecklistProgressStore((state) => state.totalSteps);
	const { isVisibleForOrientation, closeOnboarding, openForOrientation } =
		usePhotoOnboardingStore();

	return (
		<>
			{!!isVisibleForOrientation && (
				<PhotoOnboarding buttonText="Continuar" onClick={closeOnboarding} />
			)}
			<div className="mx-auto w-full px-4">
				<div className="mx-auto flex w-full max-w-[456px] flex-col gap-2.5">
					<Badge
						className="bg-tertiary"
						testId={"span_StepHeader_step_count_badge"}
					>
						Etapa {currentStep} de {totalSteps}
					</Badge>

					<div className="flex flex-col">
						<div className="flex items-center justify-between">
							{!!title && (
								<h5 className="font-bold text-secondary text-xl">{title}</h5>
							)}
							{!!hasFileUpload && (
								<HelpCircle
									className="ml-auto size-7 text-utility-gray-500"
									onClick={openForOrientation}
								/>
							)}
						</div>
						{!!subtitle && <p className="text-sm text-tertiary">{subtitle}</p>}
					</div>
				</div>
			</div>
		</>
	);
};
